import React, { FunctionComponent } from "react";
import { Demo } from "../components/demo";
import { ComponentProps } from "../components/component-props";

const dialogCode = `const DialogDemo = () => {
    const [open, setOpen] = React.useState(false);

    const EditDialog = () => {
        const [value, setValue] = React.useState("");

        return (
            <Dialog
                open={true}
                title="Modal dialog"
                dismissLabel="Cancel"
                confirmLabel="Accept"
                enableConfirm={!!value}
                onInteraction={evt => setOpen(false)}
            >
                <TextField outlined value={value}
                    onChange={({currentTarget}) => setValue(currentTarget.value)} />
            </Dialog>
        );
    };

    return (
        <>
            <TextButton contained onClick={() => setOpen(true)}>Open modal dialog</TextButton>
            {open && <EditDialog />}
        </>
    );
};

render(<DialogDemo />);`;

const dialogDemo = {
    code: dialogCode,
    noInline: true
};

export const DialogDemo: FunctionComponent = () => {
    return (
        <Demo demo={dialogDemo}>
            <ComponentProps componentName="Dialog" />
        </Demo>
    );
};
